export default __webpack_public_path__ + "static/media/kinetiq.41a921ad.png";